import { render, staticRenderFns } from "./importdata-debitur.vue?vue&type=template&id=b155edec&scoped=true&"
import script from "./importdata-debitur.vue?vue&type=script&lang=js&"
export * from "./importdata-debitur.vue?vue&type=script&lang=js&"
import style0 from "./importdata-debitur.vue?vue&type=style&index=0&id=b155edec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b155edec",
  null
  
)

export default component.exports